const axios = require('axios');

export function sendFormData(id, name, email, subject, message) {
    var body = {
        id: id,
        text:
            '<b>Nome:</b>' + name +
            '<br /><b>Email:</b>' + email +
            '<br /><br /> <b>Assunto:</b>' + subject +
            '<br /><b>Mensagem:</b>' + message
    };

    // return axios.post('localhost:3000/email', body);
    return axios({
        method: 'post',
        url: 'https://sw42-email-service-cyhcjc3sia-no.a.run.app/email',
        headers: {
            'Access-Control-Allow-Origin': '*'
        },
        data: body
    });
}
